module.exports = __webpack_public_path__ + "img/blue-telefone-icon.da485cee.svg";